/** FuryBot — Free Tools Flow */
import { track } from "../utils/analytics";

export function createToolsFlowHandlers(ctx) {
  const { addBot } = ctx;

  const startToolsFlow = () => {
    track("flow_started", { flow: "tools" });
    addBot("Free tools to help you research before buying an eval:\n\n**Drawdown Visualizer** \u2014 See how trailing vs EOD drawdown tightens day-by-day\n**VIX Fear Gauge** \u2014 Check market volatility before you trade\n**Payout Estimator** \u2014 Calculate your take-home after splits\n\nWhich tool interests you?", [
      { label: "Drawdown Visualizer", action: "link", data: "/drawdown-calculator" },
      { label: "VIX Fear Gauge", action: "link", data: "/tools" },
      { label: "Payout Estimator", action: "link", data: "/tools" },
      { label: "Why traders fail evals", action: "beginner_walk", data: "2" },
      { label: "Pick a firm", action: "flow_match" },
      { label: "Main menu", action: "home" },
    ]);
  };

  return { startToolsFlow };
}
